// VisitorTracker — traccia le visite del SOLO sito pubblico (una riga per cambio rotta).
// Montato globalmente dentro il Router. Non traccia mai le aree private/CRM.
import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { trackVisit } from '@/services/analytics.service';

// Prefissi delle aree NON pubbliche (CRM, aree riservate, pagine con token).
const EXCLUDED = [
  '/admin', '/area', '/cliente', '/staff', '/rider', '/waiter', '/cameriere',
  '/partner', '/login', '/register', '/guida/registrati', '/guida/accedi',
  '/t/', '/traccia', '/spedizione', '/fattura', '/reclamo', '/paga',
  '/prenotazione', '/biglietto', '/parchi-preview', '/intro-test',
];

function isPublic(pathname) {
  return !EXCLUDED.some((p) => pathname === p || pathname.startsWith(p + '/') || pathname.startsWith(p));
}

export default function VisitorTracker() {
  const location = useLocation();
  const lastRef = useRef({ path: null, at: 0 });

  useEffect(() => {
    const path = location.pathname || '/';
    if (!isPublic(path)) return;
    const now = Date.now();
    // Dedup: evita doppioni ravvicinati (StrictMode / re-render) sulla stessa rotta.
    if (lastRef.current.path === path && now - lastRef.current.at < 1500) return;
    lastRef.current = { path, at: now };

    let utmSource = '';
    try { utmSource = new URLSearchParams(location.search || '').get('utm_source') || ''; } catch { /* noop */ }

    // Piccolo delay per lasciar aggiornare document.title alla pagina.
    const id = setTimeout(() => {
      trackVisit({
        path,
        referrer: (typeof document !== 'undefined' && document.referrer) || '',
        title: (typeof document !== 'undefined' && document.title) || '',
        utmSource,
      });
    }, 350);
    return () => clearTimeout(id);
  }, [location.pathname, location.search]);

  return null;
}
